import React from 'react';
import { FetchEmployeeResult, FetchTeamResult } from '../types';
import styled from 'styled-components';
import EmployeeCard from './EmployeeCard';
import css from '@styled-system/css';

const Content = styled.div`
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const CardCol = styled.div`
  ${css({
    width: ['100%', 'calc(50% - 1rem)', 'calc(33% - 1rem)']
  })}
  padding-left: ${props => props.theme.space.small};
  padding-right: ${props => props.theme.space.small};
  margin-bottom: ${props => props.theme.space.medium};
`;

const CardContainer = styled.div`
  display: grid;
`;

const TeamBanner = styled.div`
  height: ${props => props.theme.space.xxlarge};
  margin-bottom: ${props => props.theme.space.large};
  margin-top: ${props => props.theme.space.xxxlarge};
  padding: 0 ${props => props.theme.space.medium};
  background: ${props => props.theme.ruleColor};
  border-radius: ${props => (props.theme.name === 'Skjernbank' ? '4px' : '0')};
  width: 100%;
`;

const Header = styled.div`
  color: #fff;
  font-size: 1rem;
  font-weight: 400;
  line-height: ${props => props.theme.space.xxlarge};
`;

type EmployeeTableProps = {
  employees: FetchEmployeeResult[];
  teams?: FetchTeamResult[] | null;
  url?: string | undefined;
  nextRouter?: any;
};

export default function EmployeeTable(props: EmployeeTableProps) {
  const { employees, url, teams, nextRouter } = props;
  let listItems;
  if (employees) {
    listItems = employees.map((employee: FetchEmployeeResult) => (
      <CardCol key={employee.employeeId}>
        <EmployeeCard
          employee={employee}
          url={url}
          nextRouter={nextRouter}
        ></EmployeeCard>
      </CardCol>
    ));
  }

  let teamItems;
  if (teams) {
    teamItems = teams.map((team: FetchTeamResult) => {
      const teamEmployees = team.employees.map(
        (employee: FetchEmployeeResult) => (
          <CardCol key={employee.employeeId}>
            <EmployeeCard
              employee={employee}
              url={url}
              nextRouter={nextRouter}
            ></EmployeeCard>
          </CardCol>
        )
      );

      return (
        <Content key={team.id}>
          <TeamBanner>
            <Header>{team.name}</Header>
          </TeamBanner>
          {teamEmployees}
        </Content>
      );
    });
  }

  return (
    <>
      <CardContainer data-testid="employee-table">
        <Content>{listItems}</Content>
        {teams && teamItems}
      </CardContainer>
    </>
  );
}
